<template>
    <div :class="['CustomCursor grid', {'is-text': isText}, {'is-hover': isHover}, {'is-black': $route.name == 'about' }]">
        <div class="CustomCursor-container grid">
            <transition name="title" mode="out-in">
                <div :class="['CustomCursor-content',  {'is-from-empty': isFromEmpty}]" v-bind:key="store.state.cursorText">
                    <div class="CustomCursor-text-container">
                        <span class="CustomCursor-text">{{store.state.cursorText}}</span>
                    </div>
                    <div class="CustomCursor-bar"></div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

import Store from '@/stores/store.js'
import Raf from '@/utils/raf.js'

export default {
    name: 'CustomCursor',
    
    data(){
        return{
            store: Store,
            isFromEmpty: true,
            cursor: {
                target: {
                    x: Store.state.mouse.x,
                    y: Store.state.mouse.y
                },
                current: {
                    x: Store.state.mouse.x,
                    y: Store.state.mouse.y
                },
                size:{
                    width: 100,
                    height: 100
                },
                ease: 1,
            }
        }
    },


    beforeDestroy() {
        Raf.remove(this.update)
    },

    mounted(){
        this.cursor.target.x = this.cursor.target.x - this.offset.x;
        this.cursor.target.y = this.cursor.target.y - this.offset.y;

        this.computeCursorSize();

        document.addEventListener('mousemove', this.onMouseMoveOverlay)
        Raf.add(this.update)
    },

    methods: {
        computeCursorSize(){
            this.cursor.size = this.$el.getBoundingClientRect();
        },
        onMouseMoveOverlay(e){
            this.cursor.target = { x : e.clientX - this.offset.x, y: e.clientY - this.offset.y };
        },
        update(){
            this.cursor.current.x += (this.cursor.target.x - this.cursor.current.x) * this.cursor.ease;
            this.cursor.current.y += (this.cursor.target.y - this.cursor.current.y) * this.cursor.ease;
            this.$el.style.transform = `translate(${ this.cursor.current.x }px, ${ this.cursor.current.y }px)`;
        }
    },

    computed: {
        isText(){
            return this.store.state.cursorText !== '';
        },
        isHover() {
            return this.store.state.cursorHover
        },
        offset(){
            return { x: this.cursor.size.width/2, y: this.cursor.size.height/2}
        }
    },

    watch: {
        //Prevent the leave animation if comming from ''
        'store.state.cursorText': function (val) {
            if ( val == ''){
                this.isFromEmpty = true
            }else{
                this.isFromEmpty = false
            }
        }
    },
    
}
</script>


<style scoped lang="scss">
    .CustomCursor{
        position: fixed;
        z-index: zindex(cursor);

        width: 80px;
        height: 80px;
        
        pointer-events: none;

        &-container{
            width: 100%;
            height: 100%;
            
            border: 2px solid #4C4C4C;
            border-radius: 50%;
            
            background-color: rgba(0,0,0,0.2);
            transform: scale(0.75, 0.75) translateZ(0);
            transition: background-color 0.6s $ease-out-quint, transform 0.6s $ease-out-quint;
            will-change: transform, background-color;

            .is-black &{
                background-color: rgba(255,255,255,0.3);
            }

            .is-text &{
                transform: translateZ(0);
            }

            .is-hover &{
                transform: scale(1.1, 1.1) translateZ(0);
            }
        }

        &-text{
            display: block;
            text-transform: uppercase;
            pointer-events: none;
            
            transform: translateZ(0);
            transition: transform 0.6s $ease-out-quint, color 0.6s $ease-out-quint;
            will-change: transform, color;
            
            font-variation-settings: "wght" 700, "wdth" 60;
            font-size: 15px;

            &-container {
                width: 100%;
                height: 12px;
                overflow: hidden;
            }
            .is-black &{
                color: color(black);
            }
        }

        &-bar{
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 38px);
            pointer-events: none;
            width: 4px;
            height: 4px;
            background-color: color(white);
            
            transition: transform 0.75s $ease-out-quint, background-color 0.6s $ease-out-quint;

            .is-text &{
                transform: translate(-50%, 50px) scale(9.5, 0.5);
            }
            .is-black &{
                background-color: color(black);
            }
        }
    }




    // // // // // // // // // 
    // TRANSITION HANDLING //
    // // // // // // // // // 

    .title-enter, .title-leave-to {
        opacity: .95;
        .CustomCursor-text{ transform: translateY(30px) translateZ(0); }
        .CustomCursor-bar{ transform: translate(-50%, 55px); }
    }
    .title-enter-active{
        transition: opacity 0.6s linear;
        .CustomCursor-text{ 
            transition: transform 0.5s $ease-out-quint 0.1s;
        }
        .CustomCursor-bar{ 
            transition: transform 0.6s $ease-out-quint;
        }
    }
    .title-leave-active{
        transition: opacity .3s linear;
        &.is-from-empty{
            transition: none; //Prevent the leave animation if comming from ''
        }
        .CustomCursor-text{
            transition: transform 0.3s $ease-out-quad;
        }
        .CustomCursor-bar{ 
            transition: transform 0.25s $ease-out-quad .05s;
        }
    }
</style>